module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<tr name=\"attribute-")
    ; __append(escapeFn( attribute.index ))
    ; __append("\">\n    <td></td>\n    <td>\n        <control index=\"")
    ; __append(escapeFn( attribute.index ))
    ; __append("\" type=\"text\" html-name=\"name\" html-placeholder=\"Введите имя\" target=\"item.attributes[")
    ; __append(escapeFn( attribute.index ))
    ; __append("].name\"/>\n    </td>\n    <td>\n        <control index=\"")
    ; __append(escapeFn( attribute.index ))
    ; __append("\" type=\"text\" html-name=\"description\" html-placeholder=\"Введите описание\" target=\"item.attributes[")
    ; __append(escapeFn( attribute.index ))
    ; __append("].description\"/>\n    </td>\n    <td>\n        <control index=\"")
    ; __append(escapeFn( attribute.index ))
    ; __append("\" type=\"enum-select\" enum=\"Spatial.AttributeType\"  html-name=\"type\" target=\"item.attributes[")
    ; __append(escapeFn( attribute.index ))
    ; __append("].type\" prepend=\"Выберите тип:\"/>\n    </td>\n</tr>")
  }
  return __output.join("");

}